import React from "react";

export function WorkListView({
  emptyText = "No work items found.",
  onOpenRecord = () => {},
  openActionLabel = "Open",
  records = [],
  saving = false,
}) {
  return (
    <div className="functional-record-table-wrap">
      <table className="functional-record-table">
        <thead>
          <tr>
            <th>Key</th>
            <th>Title</th>
            <th>Type</th>
            <th>Owner</th>
            <th>Priority</th>
            <th>Status</th>
            <th>Due</th>
            <th>Sprint</th>
            <th aria-label="Actions" />
          </tr>
        </thead>
        <tbody>
          {records.map((record) => (
            <tr key={record.id}>
              <td>{record.id}</td>
              <td><strong>{record.title}</strong></td>
              <td>{record.type}</td>
              <td>{record.owner || "Unassigned"}</td>
              <td><span className={`priority ${`${record.priority || "medium"}`.toLowerCase()}`}>{record.priority || "Medium"}</span></td>
              <td><span className="people-table-status">{record.status}</span></td>
              <td>{record.due || "—"}</td>
              <td>{record.sprint || "—"}</td>
              <td><button disabled={saving} onClick={() => onOpenRecord(record)} type="button">{openActionLabel}</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {!records.length ? <p className="empty-state">{emptyText}</p> : null}
    </div>
  );
}
